import { MONTH, MONTHFA } from "../assets/js/constants.js";
import type { IRecommendation, IProduct } from "../types/general";
export function formattedDate(val: Date) {
  if (val) {
    const year = val.getFullYear();
    const month = String(val.getMonth() + 1).padStart(2, "0");
    const day = String(val.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  } else {
    return "";
  }
}
export function formattedDateMonthName(val: Date, locale: string = "en") {
  const day = val.getDate();
  const monthIndex = val.getMonth();
  const year = val.getFullYear();
  // const monthName = MONTH[monthIndex];
  const monthName = locale === "fa" ? MONTHFA[monthIndex] : MONTH[monthIndex];
  return `${day} ${monthName} ${year}`;
}

export function addDaysToDate(dateStr: string, daysToAdd: number) {
  const date = new Date(dateStr);
  date.setDate(date.getDate() + daysToAdd);
  return formattedDate(date);
}

export function formattedDateMonthNameTime(val: Date) {
  const result = formattedDateMonthName(val);
  const hour = val.getHours();
  const min = val.getMinutes();
  return result + " - " + hour + ":" + min;
}

export function recommendationRow(
  row: number,
  recommendationList: IRecommendation[],
  productsList: IProduct[],
  chunkSize: number,
  beforeSlice: number = 0, // number of products that we show in previous rows
  designRow: number //number of row in design
) {
  const dividedArray = divideArrayIntoChunks(
    productsList,
    chunkSize,
    beforeSlice
  );
  if (row == 0) {
    // 0 for the rest of products in the page when we have recommendation row in index
    if (designRow <= recommendationList?.length) {
      return { title: "optional", products: dividedArray[0] };
    } else {
      const productsIndex = designRow - recommendationList?.length;
      if (dividedArray?.length < productsIndex) {
        //when products are less than expected
        return {
          title: "optional",
          products: null,
        };
      } else {
        return {
          title: "optional",
          products: dividedArray[productsIndex],
        };
      }
    }
  } else {
    const rowTmp = row - 1;
    if (recommendationList?.length > 0) {
      if (row <= recommendationList?.length) {
        return recommendationList[rowTmp];
      } else {
        const tmp: number = recommendationList?.length;
        if (beforeSlice == 0) {
          return { title: "optional", products: dividedArray[row - tmp] };
        } else {
          return { title: "optional", products: dividedArray[0] };
        }
      }
    } else {
      if (beforeSlice == 0) {
        return { title: "optional", products: dividedArray[rowTmp] };
      } else {
        return { title: "optional", products: dividedArray[0] };
      }
    }
  }
}
function divideArrayIntoChunks(
  array: IProduct[] | IRecommendation[],
  chunkSize: number,
  beforeSlice: number = 0
) {
  const chunks: (IProduct[] | IRecommendation[])[] = [];
  const tmp = beforeSlice == 0 ? array : array.slice(beforeSlice);

  for (let i = 0; i < tmp?.length; i += chunkSize) {
    chunks.push(tmp.slice(i, i + chunkSize)); // Slice the array into chunks of exactly `chunkSize`
  }

  return chunks;
}
